import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  // ❌ NE PAS définir Content-Type ici - laissez Axios le gérer automatiquement
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    // ✅ CORRECTION CRITIQUE : Gérer automatiquement le Content-Type
    if (config.data instanceof FormData) {
      // Si c'est FormData, supprimer le Content-Type pour laisser Axios le gérer
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      // Sinon, utiliser application/json par défaut
      config.headers['Content-Type'] = 'application/json';
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// ─── Refresh automatique de l'access token (TTL 5 min côté backend) ───
// Sur un 401, on appelle /auth/refresh une seule fois (les requêtes 401
// concurrentes attendent la même promesse), puis on rejoue la requête.
// Les callbacks sont injectés depuis store.js pour éviter un import circulaire.
const AUTH_ROUTES = ['/auth/signin', '/auth/refresh'];
let refreshPromise = null;
let onTokensRefreshed = () => {};
let onRefreshFailed = () => {};

export const setupAuthInterceptor = ({ onRefreshed, onFailed }) => {
  onTokensRefreshed = onRefreshed;
  onRefreshFailed = onFailed;
};

const refreshTokens = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) throw new Error("No refresh token");

  // axios brut (pas `api`) pour ne pas repasser par cet intercepteur
  const { data } = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/auth/refresh`,
    {},
    { headers: { Authorization: `Bearer ${refreshToken}` } }
  );

  localStorage.setItem("accessToken", data.accessToken);
  localStorage.setItem("refreshToken", data.refreshToken);
  onTokensRefreshed(data);
  return data.accessToken;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isAuthRoute = AUTH_ROUTES.some((route) => original?.url?.includes(route));

    if (error.response?.status !== 401 || !original || original._retry || isAuthRoute) {
      return Promise.reject(error);
    }
    original._retry = true;

    try {
      if (!refreshPromise) {
        refreshPromise = refreshTokens().finally(() => {
          refreshPromise = null;
        });
      }
      await refreshPromise;
      // L'intercepteur de requête remettra le nouveau token depuis le localStorage
      return api(original);
    } catch (refreshError) {
      onRefreshFailed();
      return Promise.reject(error);
    }
  }
);

export default api;
